import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card } from '../UI';
import ProjectCard from '../Projects/ProjectCard';
import axios from '../../axios';
import classes from './Overview.module.css';

const Overview = () => {
  const navigate = useNavigate();
  const [projects, setProjects] = useState([]);
  const [devicesCount, setDevicesCount] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchOverviewData = async () => {
      try {
        setLoading(true);
        const response = (await axios.get('/overview')).data;
        setProjects(response.recentProjects);
        setDevicesCount(response.devicesCount);
        setLoading(false);
      } catch (error) {
        console.error('Failed to fetch overview data:', error);
        setLoading(false);
      }
    }

    fetchOverviewData()
  }, []);

  const formattedProjects = projects.slice(0, 3);

  return (
    <div className={classes.overview}>
      {loading ? (
        <div className={classes.loading}>Loading...</div>
      ) : (
        <div className={classes.overviewContent}>
          <section className={classes.section}>
            <h2 className={classes.sectionTitle}>Devices</h2>
            <div className={classes.cardsGrid}>
              <Card className={classes.devicesCard}>
                <div className={classes.devicesCardInner}>
                  <div className={classes.devicesCount}>{devicesCount}</div>
                  <div className={classes.devicesLabel}>devices claimed</div>
                </div>
              </Card>

              <div
                className={classes.inlineAction}
                onClick={() => navigate('/devices/claim-device')}
              >
                <h1>Add extra</h1>
                <h1>→</h1>
              </div>
            </div>
          </section>

          <section className={classes.section}>
            <div className={classes.sectionHeaderRow}>
              <h2 className={classes.sectionTitle}>Recent projects</h2>
            </div>

            <div className={classes.cardsGrid}>
              {formattedProjects.map((project) => (
                <ProjectCard
                  key={project._id}
                  project={project}
                  onClick={(projectId) => navigate(`/project/${projectId}`)}
                />
              ))}
              <div
                className={classes.inlineAction}
                onClick={() => navigate('/projects')}
              >
                <h1>See all</h1>
                <h1>→</h1>
              </div>
            </div>
          </section>
        </div>
      )}
    </div>
  );
};

export default Overview;

